/* @flow */
import React from 'react';

import './styles/CheckboxCopy.scss';

/**
 * CheckboxCopy is a component for lining up paragraphs & lists with Checkbox labels, and styling
 * them to match a Checkbox label note
 *
 * ```example
 *  <CheckboxCopy>
 *    <Checkbox label="A checkbox label">
 *    <p>
 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean eget rhoncus nunc, eget
 *     commodo felis. Vestibulum mattis mi tortor, id imperdiet ex imperdiet in.
 *    </p>
 *    <ol>
 *      <li>Lorem ipsum dolor sit amet</li>
 *      <li>Lorem ipsum dolor sit amet</li>
 *      <li>Lorem ipsum dolor sit amet</li>
 *    </ol>
 *    <ul>
 *      <li>Lorem ipsum dolor sit amet</li>
 *      <li>Lorem ipsum dolor sit amet</li>
 *      <li>Lorem ipsum dolor sit amet</li>
 *    </ul>
 *  </CheckboxCopy>
 * ```
 */

export default class CheckboxCopy extends React.Component {
  render() {
    return (
      <div className="CheckboxCopy">
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CheckboxCopy.jsx